import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = 'Hello! I want to know about available puppies at Petsmart Puppies Noida.';
    const whatsappUrl = `https://wa.me/917217648679?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {/* Desktop only - floating WhatsApp button */}
      <button
        onClick={handleWhatsAppClick}
        data-testid="whatsapp-floating-button"
        className="whatsapp-desktop-btn hidden md:flex items-center justify-center transition-all hover:scale-110 active:scale-100"
        style={{
          position: 'fixed',
          bottom: '1.5rem',
          right: '1.5rem',
          backgroundColor: '#25D366',
          color: 'white',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
          zIndex: 980,
          border: 'none',
          cursor: 'pointer'
        }}
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={26} />
      </button>

      <style>{`
        /* Hide on mobile since sticky bar handles WhatsApp */
        @media (max-width: 768px) {
          .whatsapp-desktop-btn {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;
